module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo07-nikon-ecc9b4610243a3e5db33bfdb1f240b72.jpg";